





































































import BoolFilter from "@/components/Filter/BoolFilter.vue";
import NumericFilter from "@/components/Filter/NumericFilter.vue";
import { FilterType } from "@/components/Filter/FilterGenerator";
import { mapGetters } from "vuex";
import { getTranslationMixin } from "@/mixins/getTranslationMixin";
import { maximaleLengte_filterOpties } from "@/variabele";

let labelMeer = false;

export default {
  name: "FilterMenu",
  components: {
    NumericFilter,
    BoolFilter
  },
  mixins: [getTranslationMixin],
  methods: {
    resetLabelMeer() {
      labelMeer = !labelMeer;
    },
    setToShow() {
      labelMeer = true;
    },
    getLabelMeer() {
      return labelMeer;
    },
    shouldRenderLabel() {
      if (this.labelMeer == false) {
        this.labelMeer = true;
        return true;
      } else {
        return false;
      }
    },
    isBoolCollectionFilter(type: FilterType) {
      if (type === FilterType.boolCollection) {
        return true;
      }

      return false;
    },
    isNumericFilter(type: FilterType) {
      if (type === FilterType.numeric) {
        return true;
      }

      return false;
    },
    isOptionFiltes(type: FilterType) {
      if (type === FilterType.option) {
        return true;
      }

      return false;
    },
    removeAllFilters() {
      this.$store.dispatch("resetFilters");
    }
  },
  computed: {
    ...mapGetters(["getcurrentFilters", "isFiltered"]),
    maximum() {
      return maximaleLengte_filterOpties;
    }
  }
};
